import { useEffect, useRef, useState } from "react"
import { useFrame } from "@react-three/fiber"
import { useAnimations } from "@react-three/drei"
import { FollowPathBehavior, Path, SteeringManager, Vector3, Vehicle } from "yuka"
import { PATHS } from "../start-birds-wrap"
import { MeshStandardMaterial } from "three"


const StartBird = ({start, birdColor, scene, animations}) => {
  const [startPoint] = useState(new Vector3(start.x, start.y, start.z))
  const [targetRotation] = useState(Math.PI)
  const [state, setState] = useState("idle")
  const modelRef = useRef();
  const { actions, mixer } = useAnimations(animations, modelRef);
  const steeringManager = useRef(new SteeringManager()); // Менеджер для агентів
  const birdAgent = useRef(null); // Агент пташки
  const [lastPathPoint, setLastPathPoint] = useState(null);
  const [isOnlyStart, setIsOnlyStart] = useState(false)


  useEffect(() => {
    if (state === 'fly') {
      actions['idle']?.fadeOut(0.5);
      actions['fly']?.reset().fadeIn(0.5).play();
    }
    if (state === 'return') {
      actions['fly']?.fadeOut(0.05);
      actions['back']?.reset().fadeIn(0.05).play();
    }
    if (state === 'idle') {
      actions['back']?.fadeOut(0.5);
      actions['idle']?.reset().fadeIn(0.5).play();
    }
  }, [state])

  const playAnimation = () => {
    setState('fly')

    setLastPathPoint(start);
    setIsOnlyStart(true)
    setTimeout(() => {
      setIsOnlyStart(false)
    }, 3000)


    // Визначаємо точки шляху

    const path = new Path();
    const randomIndex = Math.floor(Math.random() * PATHS.length);
    const randomPath = PATHS[randomIndex];

    randomPath.points.map(item => {
      path.add(new Vector3(item.x, item.y, item.z))
    })

    //path.add(new Vector3(start.x, start.y, start.z))

    // Поведінка для слідування за шляхом
    const followPathBehavior = new FollowPathBehavior(path, 1); // Другий аргумент — це радіус шляху
    followPathBehavior.arrivalTolerance = 0.1;
    birdAgent.current.steering.add(followPathBehavior); // Додаємо поведінку агенту
    birdAgent.current.position.set(start.x, start.y, start.z);
    steeringManager.current.add(birdAgent.current);
  }

  useEffect(() => {
    // Створюємо новий матеріал для заміни
    const newMaterial = new MeshStandardMaterial({ color: birdColor });

    // Проходимо через всі меші в сцені
    scene.traverse((child) => {
      if (child.isMesh && child.material.name === 'lambert2.001') {
        child.material = newMaterial;  // Заміна матеріалу
      }
    });

    // Створюємо агента пташки
    birdAgent.current = new Vehicle();
    birdAgent.current.maxSpeed = 6; // Швидкість пташки
    birdAgent.current.maxAngularAcceleration = 10;
    birdAgent.current.position.set(start.x, start.y, start.z);
    modelRef.current.position.copy(birdAgent.current.position);
    actions['idle'].play();

   setTimeout(() => {
     playAnimation()
   }, Math.random() * 3000)

  }, [])

  useFrame((_, delta) => {
    if (state === 'idle') {
      // Calculate rotation towards the target
      const currentRotation = modelRef.current.rotation.y;
      const rotationDelta = targetRotation - currentRotation;
      modelRef.current.rotation.y = currentRotation + rotationDelta * 0.5;
    }

    if (modelRef.current && birdAgent.current) {
      // Оновлюємо агента
      if (state === 'fly') {
        birdAgent.current.update(delta);

        modelRef.current.position.copy(birdAgent.current.position);

        // Оновлюємо позицію моделі згідно з позицією агента
        modelRef.current.quaternion.copy(birdAgent.current.rotation);
        modelRef.current.rotateY(-(Math.PI / 2));
      }

      if (state === 'fly' && !isOnlyStart) {
        const distance = birdAgent.current.position.distanceTo(lastPathPoint);
        if (distance < 2) {
          birdAgent.current.steering.behaviors.forEach(behavior => {
            birdAgent.current.steering.remove(behavior);
          });
          setState('return')

        }
      }

      if (state === 'return') {
        const currentPosition = new Vector3(modelRef.current.position.x, modelRef.current.position.y, modelRef.current.position.z);
        const direction = startPoint.clone().sub(currentPosition).normalize();
        modelRef.current.position.add(direction.multiplyScalar(delta)); // Adjust speed as needed


        // Check if model is close enough to start point
        if (currentPosition.distanceTo(startPoint) < 0.05) {
          modelRef.current.position.copy(startPoint);



          setState("idle")
          setTimeout(() => {
            playAnimation()
          }, 8000)
        }
      }
    }

    // Оновлюємо анімації
    mixer?.update(delta);
  });

  return <primitive ref={modelRef} object={scene} />;
};

export {
  StartBird
}